"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusType = exports.profileType = exports.phoneNumberType = exports.nameType = exports.incomeType = exports.educationType = exports.documentType = exports.consentType = exports.addressType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var nameType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  firstName: _propTypes.default.string,
  lastName: _propTypes.default.string,
  suffix: _propTypes.default.string
});

exports.nameType = nameType;

var phoneNumberType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  type: _propTypes.default.string,
  number: _propTypes.default.string
});

exports.phoneNumberType = phoneNumberType;

var addressType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  street1: _propTypes.default.string,
  street2: _propTypes.default.string,
  city: _propTypes.default.string,
  state: _propTypes.default.string,
  zip: _propTypes.default.string,
  type: _propTypes.default.string,
  typeDescription: _propTypes.default.string,
  ownership: _propTypes.default.string,
  ownershipDescription: _propTypes.default.string,
  ownerLegalName: _propTypes.default.string
});

exports.addressType = addressType;

var educationType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  schoolCode: _propTypes.default.string,
  startDate: _propTypes.default.string,
  endDate: _propTypes.default.string,
  degreeLevel: _propTypes.default.string,
  degreeComplete: _propTypes.default.bool
});

exports.educationType = educationType;

var incomeType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  employer: _propTypes.default.string,
  amount: _propTypes.default.number
});

exports.incomeType = incomeType;

var documentType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  type: _propTypes.default.string,
  name: _propTypes.default.string
});

exports.documentType = documentType;

var consentType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  type: _propTypes.default.string,
  version: _propTypes.default.number,
  optStatus: _propTypes.default.string
});

exports.consentType = consentType;

var statusType = _propTypes.default.shape({
  aliasVerified: _propTypes.default.bool
});

exports.statusType = statusType;

var profileType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  name: nameType,
  dob: _propTypes.default.string,
  citizenship: _propTypes.default.string,
  phoneNumbers: _propTypes.default.arrayOf(phoneNumberType),
  addresses: _propTypes.default.arrayOf(addressType),
  documents: _propTypes.default.arrayOf(documentType),
  consents: _propTypes.default.arrayOf(consentType),
  educations: _propTypes.default.arrayOf(educationType),
  income: incomeType,
  maritalStatus: _propTypes.default.string,
  maritalStatusDescription: _propTypes.default.string,
  hasSsn: _propTypes.default.bool,
  status: statusType,
  type: _propTypes.default.string
});

exports.profileType = profileType;